<template>
    <div>
        <div class="columns toolbar-box">
            <div class="column is-2">
                <h1 class="title is-3 between-center">
                    <span>
                        <span>Services</span>
                        <a href="#" @click.prevent="isTableSettingsModalActive = true" class="gear">
                            <o-icon pack="fa" icon="gear" size="is-small"/>
                        </a>
                    </span>
                </h1>
            </div>
            <div class="column is-2">
                <o-field>
                    <o-select placeholder="Status" v-model="filters.type" :expanded="true">
                        <option :value="null">Not Specified</option>
                        <option
                            v-for="type in serviceTypes"
                            :value="type.id"
                            :key="type.id">
                            {{ type.name }}
                        </option>
                    </o-select>
                </o-field>
            </div>
            <div class="column is-2">
                <o-field>
                    <o-input v-model="filters.search" placeholder="Search" />
                </o-field>
            </div>
            <div class="column is-6">
                <div class="field is-grouped is-grouped-right">
                    <p v-if="checkedRows.length" class="control">
                        <a @click.prevent="confirmCustomDelete" class="button is-danger"><span>Delete selected</span></a>
                    </p>
                    <p class="control">
                        <a @click="handleCreate" class="button is-info"><span class="icon"><i class="icm-new"></i></span><span>New</span></a>
                    </p>
                </div>
            </div>
        </div>
        <o-table
            class="fullwidth-table is-responsive is-responsive-desktop"

            v-if="isTableVisible"
            :data="filteredItems"

            default-sort="name"
            v-bind="table"
            :selected.sync="selected"
            :checked-rows="checkedRows"
@update:checkedRows="$event => checkedRows = $event"
        >
            <template>
                <template>
                    <o-table-column
                        v-for="col in tableColumns"
                        v-bind="col"
                        #default="{ row }"
                        :field="col.field"
                        :label="col.field === 'actions' ? '' : col.label"
                        :sortable="col.sortable"
                    >
                        <router-link v-if="col.field === 'last_editor_id'" :to="{ name: 'users.show', params: { slug: row.last_editor_id } }">
                            {{ userNameById(row.last_editor_id) }}
                        </router-link>
                        <span v-if="col.field === 'is_initial'">{{ $filters.yesNo(row.is_initial) }}</span>
                        <span v-if="col.field === 'is_optional'">{{ $filters.yesNo(row.is_optional) }}</span>
                        <span v-if="col.field === 'title'">{{ row.title }}</span>
                        <span v-if="col.field === 'description'" v-html="row.description"></span>
                        <span v-if="col.field === 'price'">{{ $filters.currency(row.price) }}</span>
                        <span v-if="col.field === 'subservice_price'">{{ $filters.currency(row.subservice_price) }}</span>
                        <span v-if="col.field === 'is_active'">{{ $filters.yesNo(row.is_active) }}</span>
                        <span v-if="col.field === 'created_at'">{{ $filters.datetime(row.created_at) }}</span>
                        <span v-if="col.field === 'updated_at'">{{ $filters.datetime(row.updated_at) }}</span>

                        <dropdown-quick-edit :disabled="!isCurrentUserAdmin"
                                             v-if="col.field === 'reimbursable'"
                                             :entity="row"
                                             field="reimbursable"
                                             :update="partialUpdateService"
                                             :options="[{id: false, name: 'No'}, {id: true, name: 'Yes'}]"
                        />

                        <o-dropdown v-if="col.field === 'actions'" hoverable position="bottom-left" class="table-actions">
                          <template v-slot:trigger>
                            <button class="button">
                              <o-icon pack="fa" icon="ellipsis-v"></o-icon>
                            </button>
                          </template>
                            <o-dropdown-item has-link><a @click.stop.prevent="handleEdit(row)">Edit</a></o-dropdown-item>
                        </o-dropdown>
                    </o-table-column>
                </template>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              This table is empty!
            </div>
          </template>
        </o-table>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="editModalActive" has-modal-card>
            <service-modal :item="editItem" />
        </o-modal>

       <o-modal :can-cancel="['escape', 'outside', 'button']" scroll="keep" v-model:active="isTableSettingsModalActive" has-modal-card class="table-settings-modal">
            <table-settings-modal :slug="tableName"/>
        </o-modal>
    </div>
</template>

<script>
    import ServiceModal from '../../components/modals/Service'
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../../mixins/Table'

    export default {
        mixins: [Table],

        components: {
            ServiceModal,
        },

        data() {
            return {
                tableName: 'services-index',
                currentService: null,
                isServiceModalActive: false,
                filters: {
                    type: null,
                    search: ''
                },
                serviceTypes: [
                    {"id": 1, "name": "Proposed"},
                    {"id": 2, "name": "Added"}
                ],
                editModalActive: false,
                editItem: null,
                moment
            }
        },

        computed: {
            ...mapGetters(['services', 'userNameById', 'isCurrentUserAdmin']),

            filteredItems() {
                let f = this.filters,
                    q = this.filters.search.toLowerCase()

                return _.filter(this.services, service => {
                    return service.title.toLowerCase().includes(q) || service.description.toLowerCase().includes(q)
                })
            },
        },

        methods: {
            ...mapActions({
                removeItem: 'removeService',
                partialUpdateService: 'partialUpdateService'
            }),

            resetFilters() {
                this.filters = {
                    type: null,
                    search: ''
                }
            },

            handleCreate() {
                this.editItem = {
                    type: this.type,
                    is_active: true,
                    work_types: [],
                    subservice_price: 300
                }
                this.editModalActive = true
            },

            handleEdit(item) {
                this.editItem = item
                this.editModalActive = true
            }
        }
    }
</script>
